import { FC } from 'react';

interface SectionTitleProps {
  children: React.ReactNode;
}

export const SectionTitle: FC<SectionTitleProps> = ({ children }) => {
  return (
    <h4 className="text-[var(--neutral-black-NB1000)]! font-[Arvo] [font-size:var(--fs-h4)]! font-bold leading-[140%] m-0!">
      {children}
    </h4>
  );
};
